import { organizationEndpoints } from '@/api/endpoints';
import type { FetcherService } from '@/services/abstract/FetcherService';
import { OrganizationService } from '@/services/abstract/OrganizationService';
import type { MessageBrokerMultiaddrDTO } from '@/types/organization/MessageBrokerMultiaddr';

export class OrganizationServiceImpl extends OrganizationService {
  constructor(private readonly fetcher: FetcherService) {
    super();
  }

  async getMessageBrokerMultiaddr(organizationId: string): Promise<MessageBrokerMultiaddrDTO> {
    return await this.fetcher.get<MessageBrokerMultiaddrDTO>(
      organizationEndpoints.getMessageBrokerMultiaddr(organizationId)
    );
  }
}
